import { ZOOM_DUR, prefersReducedMotion } from '../helpers/DanmarksKortMap.constants.js'

export function useMapZoom(wrapperRef, caches, { computeMarkers, clearMarkers }) {
  let pendingAnimationFrame = null

  const animateViewBox = (target, duration = ZOOM_DUR, onComplete = null) => {
    cancelAnimationFrame(pendingAnimationFrame)
    const svgElement = wrapperRef.value?.querySelector('svg')
    if (!svgElement || !target) return
    const { x: targetX, y: targetY, w: targetWidth, h: targetHeight } = target

    clearMarkers()

    if (prefersReducedMotion()) {
      svgElement.setAttribute('viewBox', [targetX, targetY, targetWidth, targetHeight].join(' '))
      computeMarkers()
      onComplete?.()
      return
    }

    const [fromX, fromY, fromWidth, fromHeight] = svgElement.getAttribute('viewBox').split(/[\s,]+/).map(Number)
    const startTime = performance.now()

    const animationStep = (timestamp) => {
      const progress       = Math.min((timestamp - startTime) / duration, 1)
      const easedProgress  = progress < 0.5 ? 2*progress*progress : -1+(4-2*progress)*progress
      svgElement.setAttribute('viewBox', [
        fromX + (targetX - fromX) * easedProgress,
        fromY + (targetY - fromY) * easedProgress,
        fromWidth  + (targetWidth  - fromWidth)  * easedProgress,
        fromHeight + (targetHeight - fromHeight) * easedProgress,
      ].join(' '))
      if (progress < 1) pendingAnimationFrame = requestAnimationFrame(animationStep)
      else { computeMarkers(); onComplete?.() }
    }

    pendingAnimationFrame = requestAnimationFrame(animationStep)
  }

  const zoomTargetFor = (groupAttr, key) =>
    caches[groupAttr]?.zoomTarget.get(key)

  return { animateViewBox, zoomTargetFor }
}
